import Vue from 'vue';
import VueRouter from 'vue-router';
import VueAnalytics from 'vue-analytics'
import store from '../store/index.js'

import Home from '../views/Home.vue';
import NotFound from '../views/NotFound.vue';
import Terms from '../views/Terms.vue';
import Maintenance from '../views/Maintenance.vue';

Vue.use(VueRouter);

const routes = [
  {path: '/', name: 'Home', component: Home},

  // Auth
  {path: '/masuk', name: 'Masuk', meta: {onlyGuest: true}, component: () => import('../views/Masuk.vue')},

  // Guard
  {path: '/subsidi', name: 'Subsidi', component: () => import('../views/Subsidi.vue'), meta: {requiresAuth: true}},

  {path: '/kebijakan-privasi', name: 'Terms', component: Terms},
  {path: '*', name: 'NotFound', component: NotFound },
  {path:'/maintenance', name: 'Maintenance', component: Maintenance}
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

// Middleware
router.beforeEach((to, from, next) => {
  if (to.name !== 'Maintenance' && process.env.VUE_APP_IS_DOWN == "true" ) {
   next({name: 'Maintenance'});
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/masuk')
  } else if (to.matched.some(record => record.meta.onlyGuest)) {
    if (store.getters.isLoggedIn) {
      next('/subsidi')
      return
    }
    next()
  } else {
   next()
  }
});

// Google Analytic
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTIC_TRACKING_ID,
  router
});

export default router;
